/**
 * External Imports
 */
import styled from 'styled-components';

export const SideNavLabel = styled.p`
  margin: auto 0;
`;
